import React, { useState } from "react";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";
import useInputChange from "./../../../utils/hooks/useInputChange";
import { useEffect } from "react";
import { fetchAllOffices } from "../../../redux/slice/office/officeSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux/";
import Form from "../../../components/form/Form";
import { isEmptyObject } from "./../../../utils/validators/validators";
import {
  addStaffEmploymentInfo,
  resetStaffStatus,
} from "../../../redux/slice/staff/staffSlice";

const AddEmploymentInfo = () => {
  const [error, setError] = useState({});
  const { user_permissions } = useSelector((state) => state.auth?.user);
  const { offices } = useSelector((state) => state.office);
  const {
    app_id,
    staff_records,
    pages,
    isSuccess,
    isLoading,
    isError,
    message,
  } = useSelector((state) => state.staff);
  const { nextPage } = useOutletContext();

  const [staffInputData, setStaffInputData] = useState({
    staff_id: "",
    office_id: "",
    designation: "",
    department: "",
    unit: "",
    app_id: app_id,
  });
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      dispatch(addStaffEmploymentInfo(staffInputData));
    }
  };

  const breadcrumb = {
    from: {
      title: "Add Staff",
      link: "/admin/add-staff",
    },
    current: {
      title: "employment information",
      link: null,
    },
  };

  // useEffect(() =>{
  //     if(offices.length === 0){
  //         dispatch(fetchAllOffices())
  //     }
  // },[])

  useEffect(() => {
    !app_id
      ? navigate(-1)
      : nextPage &&
        navigate(nextPage, { state: { from: location }, replace: true });
  }, [pages]);

  useEffect(() => {
    if (isSuccess) {
      navigate("/admin/add-staff/guarantor-information", {
        state: { from: location },
        replace: true,
      });
    }
    return () => {
      dispatch(resetStaffStatus());
    };
  }, [staff_records, isError, isSuccess, isLoading]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "staff module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create staff"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Staff Creation' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary'>
                    Employment Information
                  </h4>
                </div>
              </div>
              <Form
                setError={setError}
                submitHandler={handleSubmit}
                values={staffInputData}
              >
                <div className='row g-'>
                  <div className='mb-0 col-md-6'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Staff Id <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length=''
                      textname='staff id'
                      name='staff_id'
                      onChange={handleChange}
                      value={input.staff_id}
                      type='text'
                      className={`form-control ${
                        error.staff_id && "is-invalid"
                      }`}
                      id='staff_id'
                      placeholder='Staff ID'
                    />
                    {error.staff_id && (
                      <span className='invalid-feedback'>{error.staff_id}</span>
                    )}
                  </div>

                  <div className='mb-0 col-md-6'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Office <span className='text-danger'>*</span>
                    </label>
                    <select
                      textname='office'
                      name='office_id'
                      onChange={handleChange}
                      className={`form-select ${
                        error.office_id && "is-invalid"
                      }`}
                      id='office_id'
                    >
                      <option value=''>Choose office</option>
                      {offices?.offices &&
                        offices?.offices.map(({ id, office_name }) => (
                          <option key={id} value={id}>
                            {office_name}
                          </option>
                        ))}
                    </select>
                    {error.office_id && (
                      <span className='invalid-feedback'>
                        {error.office_id}
                      </span>
                    )}
                  </div>
                </div>

                <div className='row g-2'>
                  <div className='mb-3 mt-3'>
                    <label htmlFor='contact_address' className='form-label'>
                      Designation at Employment{" "}
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length='5'
                      textname='designation'
                      name='designation'
                      value={input.designation}
                      onChange={handleChange}
                      id='designation'
                      className={`form-control ${
                        error.designation && "is-invalid"
                      }`}
                      rows='6'
                      placeholder='Enter designation here'
                    ></input>
                    {error.designation && (
                      <span className='invalid-feedback'>
                        {error.designation}
                      </span>
                    )}
                  </div>
                </div>

                <div className='row g-2'>
                  <div className='mb-3'>
                    <label htmlFor='contact_address' className='form-label'>
                      Department at Employment{" "}
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length='5'
                      textname='department'
                      name='department'
                      onChange={handleChange}
                      value={input.department}
                      type='text'
                      id='department'
                      className={`form-control ${
                        error.department && "is-invalid"
                      }`}
                      rows='6'
                      placeholder='Enter department here'
                    ></input>
                    {error.department && (
                      <span className='invalid-feedback'>
                        {error.department}
                      </span>
                    )}
                  </div>
                </div>

                <div className='row g-2'>
                  <div className='mb-3'>
                    <label htmlFor='unit' className='form-label'>
                      Unit at Employment <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length='5'
                      textname='unit'
                      name='unit'
                      value={input.unit}
                      onChange={handleChange}
                      type='text'
                      id='unit'
                      validate='false'
                      className={`form-control ${error.unit && "is-invalid"}`}
                      rows='6'
                      placeholder='Enter unit here'
                    ></input>
                    {error.unit && (
                      <span className='invalid-feedback'>{error.unit}</span>
                    )}
                  </div>
                </div>

                <div className='float-end'>
                  <button
                    disabled={isLoading && true}
                    className='btn btn-primary w-10'
                  >
                    Proceed
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      {/* end content */}
    </>
  );
};

export default AddEmploymentInfo;
